import { render, staticRenderFns } from "./ShowEdit.vue?vue&type=template&id=52ea2ee8&scoped=true"
import script from "./ShowEdit.vue?vue&type=script&lang=js"
export * from "./ShowEdit.vue?vue&type=script&lang=js"
import style0 from "./ShowEdit.vue?vue&type=style&index=0&id=52ea2ee8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ea2ee8",
  null
  
)

export default component.exports